import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useMemo, useCallback } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import uuid from '@/utils/uuid';
import Tooltip from '@/components/Tooltip';
import { toStylesAttribute } from '@/utils/dom';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DropdownIcon = function DropdownIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

DropdownIcon.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var GripDotsIcon = function GripDotsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 0h24v24H0z",
      stroke: "none"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "5",
      cy: "5",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "5",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "19",
      cy: "5",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "5",
      cy: "12",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "19",
      cy: "12",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "5",
      cy: "19",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "19",
      r: "1"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "19",
      cy: "19",
      r: "1"
    })]
  }));
};

GripDotsIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  strokeWidth: "2",
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0.333344 16.5001C0.333344 16.0398 0.70644 15.6667 1.16668 15.6667H12.8333C13.2936 15.6667 13.6667 16.0398 13.6667 16.5001C13.6667 16.9603 13.2936 17.3334 12.8333 17.3334H1.16668C0.70644 17.3334 0.333344 16.9603 0.333344 16.5001Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.34308 1.64525C8.64483 0.343508 10.7554 0.343512 12.0571 1.64525L12.6882 2.27638C13.99 3.57813 13.99 5.68869 12.6882 6.99044L6.93317 12.7455C6.70198 12.9767 6.40789 13.1348 6.08752 13.2001L2.33454 13.965C1.16408 14.2036 0.130048 13.1696 0.368578 11.9991L1.13342 8.24599C1.19871 7.9256 1.3568 7.6315 1.58801 7.40029L7.34308 1.64525ZM10.8786 2.82377C10.2277 2.17289 9.17247 2.17289 8.52159 2.82376L8.17855 3.1668L11.1667 6.15495L11.5097 5.81192C12.1606 5.16105 12.1606 4.10577 11.5097 3.4549L10.8786 2.82377ZM4.01187 7.33345L7.00004 4.34531L9.98819 7.33346L7.00003 10.3216L4.01187 7.33345ZM2.83336 8.51196L2.76652 8.5788L2.00168 12.3319L5.75466 11.567L5.82151 11.5001L2.83336 8.51196Z",
      fill: "#12131A"
    })]
  }));
};

EditIcon.defaultProps = {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const AccordionDefaultPanel = _ref => {
  let {
    id,
    sortId,
    // unique sort item id
    title,
    caption,
    isNavigationalOnly = false,
    isIndicatorHidden = false,
    children,
    isEditable,
    isSorting,
    isOpen = false,
    isFullHeight,
    className,
    classes = {},
    warningText,
    sortableData = {},
    isSortTopFixed,
    isSortBottomFixed,
    isHiddenOnDrag,
    onClick = () => undefined,
    onEditTitle = () => undefined
  } = _ref;
  const sortableId = useMemo(() => typeof sortId !== 'undefined' ? sortId : uuid(), [sortId]);
  const {
    attributes,
    listeners,
    setNodeRef: sortSetNodeRef,
    isDragging,
    transform,
    transition
  } = useSortable({
    id: `${sortableId}`,
    data: sortableData,
    resizeObserverConfig: {}
  });
  const style = useMemo(() => {
    if (!transform) return {};
    if (!isDragging && isSortTopFixed && transform.y < 0) transform.y = 0;
    if (!isDragging && isSortBottomFixed && transform.y > 0) transform.y = 0;
    return toStylesAttribute({
      transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : null,
      transition
    });
  }, [isDragging, transform, transition, isSortTopFixed, isSortBottomFixed]); // Stops edit icon click propagation

  const handleEditClick = useCallback(evt => {
    evt.preventDefault();
    evt.stopPropagation();
    onEditTitle();
  }, [onEditTitle]);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, id && {
    id
  }), {}, {
    className: clsx(styles.panel, isFullHeight ? styles['panel--fullHeight'] : '', isOpen && !isSorting ? styles.isOpen : '', isOpen && !isSorting ? classes.isOpen : '', isIndicatorHidden ? styles['isOpen--noIndicator'] : '', isDragging ? styles['panel--dragging'] : '', isDragging && isHiddenOnDrag ? styles['panel--hidden'] : '', className || ''),
    ref: sortSetNodeRef,
    style: style,
    children: [/*#__PURE__*/_jsxs("label", {
      className: clsx(styles.heading, sortId ? styles['heading--sortable'] : '', classes.heading),
      ref: sortSetNodeRef // Fix for double click event bug
      ,
      onMouseDown: onClick,
      children: [sortId && /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
        type: "button",
        className: styles.sortHandle,
        onMouseDown: evt => {
          evt.preventDefault();
          evt.stopPropagation();
        }
      }, attributes), listeners), {}, {
        children: /*#__PURE__*/_jsx(GripDotsIcon, {})
      })), warningText && /*#__PURE__*/_jsx(Tooltip, {
        placement: "right",
        className: styles.heading__warning,
        content: warningText,
        children: /*#__PURE__*/_jsx("span", {
          className: styles.heading__warningIcon
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: clsx(styles.heading__text, isEditable ? styles['-isEditable'] : ''),
        children: [/*#__PURE__*/_jsx("span", {
          children: title
        }), isEditable && isOpen ? /*#__PURE__*/_jsx(EditIcon, {
          onMouseDown: handleEditClick
        }) : /*#__PURE__*/_jsx(_Fragment, {}), caption ? /*#__PURE__*/_jsx("div", {
          className: styles.heading__caption,
          children: /*#__PURE__*/_jsx(Tooltip, {
            placement: "right",
            content: caption,
            children: /*#__PURE__*/_jsx(InfoIcon, {})
          })
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), !isNavigationalOnly ? /*#__PURE__*/_jsx(DropdownIcon, {
        className: styles.heading__icon
      }) : /*#__PURE__*/_jsx("div", {
        style: {
          rotate: '-90deg'
        },
        children: /*#__PURE__*/_jsx(DropdownIcon, {
          className: styles.heading__icon
        })
      })]
    }), isOpen && !isNavigationalOnly && /*#__PURE__*/_jsx("div", {
      className: clsx(styles.panel__content, classes.content),
      children: children
    })]
  }));
};

export default AccordionDefaultPanel;